var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22723_239845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62479 10.3361C6.56527 10.1054 6.44502 9.89484 6.27653 9.72636C6.10805 9.55788 5.8975 9.43762 5.66679 9.3781L1.57679 8.32344C1.50701 8.30363 1.4456 8.2616 1.40186 8.20373C1.35813 8.14586 1.33447 8.07531 1.33447 8.00277C1.33447 7.93023 1.35813 7.85968 1.40186 7.80181C1.4456 7.74394 1.50701 7.70191 1.57679 7.6821L5.66679 6.62677C5.89742 6.56731 6.10792 6.44715 6.27639 6.2788C6.44486 6.11044 6.56517 5.90003 6.62479 5.66944L7.67946 1.57944C7.69906 1.50938 7.74105 1.44766 7.799 1.4037C7.85696 1.35974 7.92771 1.33594 8.00046 1.33594C8.0732 1.33594 8.14395 1.35974 8.20191 1.4037C8.25987 1.44766 8.30185 1.50938 8.32146 1.57944L9.37546 5.66944C9.43497 5.90015 9.55523 6.1107 9.72371 6.27918C9.89219 6.44766 10.1027 6.56792 10.3335 6.62744L14.4235 7.68144C14.4938 7.70084 14.5558 7.74278 14.6 7.80082C14.6442 7.85887 14.6682 7.92981 14.6682 8.00277C14.6682 8.07573 14.6442 8.14667 14.6 8.20472C14.5558 8.26276 14.4938 8.3047 14.4235 8.3241L10.3335 9.3781C10.1027 9.43762 9.89219 9.55788 9.72371 9.72636C9.55523 9.89484 9.43497 10.1054 9.37546 10.3361L8.32079 14.4261C8.30118 14.4962 8.2592 14.5579 8.20124 14.6018C8.14328 14.6458 8.07254 14.6696 7.99979 14.6696C7.92704 14.6696 7.85629 14.6458 7.79834 14.6018C7.74038 14.5579 7.69839 14.4962 7.67879 14.4261L6.62479 10.3361Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2V4.66667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.33594H12",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 11.3359V12.6693",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12H2",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22723_239845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.7c93c82f90ff8d8bf278e55f37bd5fea.svg";
export { ForwardRef as ReactComponent };